import { atom } from 'recoil';
import {
  getLocalStorageItem,
  IS_DEV_MODE_ENABLED,
} from '~/util/localStorageKeys';

const isDevModeEnabledState = atom<boolean>({
  key: 'isDevModeEnabled',
  default:
    typeof window !== 'undefined' &&
    getLocalStorageItem(IS_DEV_MODE_ENABLED) === 'true',
});

export default isDevModeEnabledState;
